// src/api/config.ts
import { csrfFetch } from "./csrf";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.wbl-dartliga.de/api"
    : import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api";

export const API_ENDPOINTS = {
  teams: `${API_BASE_URL}/teams/`,
  scheduleBySeason: (seasonId: string | number) =>
    `${API_BASE_URL}/schedule/seasons/${seasonId}/matchdays/`,
  matchesByMatchday: (seasonId: string | number) =>
    `${API_BASE_URL}/seasons/${seasonId}/matches-by-matchday/`,
  matchesByTeam: (seasonId: string | number, teamId: string | number) =>
    `${API_BASE_URL}/seasons/${seasonId}/team/${teamId}/matches/`,
  team: (id: string | number) => `${API_BASE_URL}/teams/${id}/`,
  seasons: `${API_BASE_URL}/seasons/`,
  playersByTeam: (teamId: string | number) =>
    `${API_BASE_URL}/players/team/${teamId}/`,
  playersByMatchId: (matchId: string | number) =>
    `${API_BASE_URL}/players/match/${matchId}/`,
  playerMatchesByMatchId: (matchId: number) =>
    `${API_BASE_URL}/matches/${matchId}/player-matches/`,
  saveMatch: `${API_BASE_URL}/match/save/`,
  matchById: (matchId: string | number) => `${API_BASE_URL}/match/${matchId}/`,
  fetchPlayedMatches: (matchId: string | number) =>
    `${API_BASE_URL}/match/${matchId}/played/`,
  playerHighlights: (playermatchId: number, playerId: number) =>
    `${API_BASE_URL}/playermatch/${playermatchId}/player/${playerId}/highlights/bulk/`,
  playerDoubleMatchHighlights: (doubleMatchId: number, playerId: number) =>
    `${API_BASE_URL}/playerdoublematch/${doubleMatchId}/player/${playerId}/highlights/bulk/`,
  homepageContent: `${API_BASE_URL}/homepage-content/`,
  files: `${API_BASE_URL}/files/`,
  postponement: (matchId: string) => `${API_BASE_URL}/postponement/${matchId}`,
  statistics: (season_id: string) => `${API_BASE_URL}/statistics/${season_id}/`,
  statistics_by_team: (season_id: string) =>
    `${API_BASE_URL}/statistics/${season_id}/`,
  // Add more endpoints as needed
};

/**
 * Centralized API request function using csrfFetch for all requests.
 * @param input RequestInfo (URL or Request object)
 * @param init RequestInit (method, headers, body, etc.)
 * @param csrfEndpoint Optional endpoint to fetch CSRF cookie if needed
 */
export async function apiRequest(
  input: RequestInfo,
  init: RequestInit = {},
  csrfEndpoint?: string
): Promise<Response> {
  return csrfFetch(input, init, csrfEndpoint);
}

export default API_ENDPOINTS;
